import { render, staticRenderFns } from "./AccountCopierSettings.vue?vue&type=template&id=281f10ac&scoped=true"
import script from "./AccountCopierSettings.vue?vue&type=script&lang=js"
export * from "./AccountCopierSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281f10ac",
  null
  
)

export default component.exports